module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/216.672bcb42.png";